import { useEffect } from 'react';

import { ECountry } from 'App/i18n/i18n.types';

import { useStoreContext } from '../hooks/useStoreContext';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void & { q?: unknown[] };
    __clarityInjected?: boolean;
  }
}

const COUNTRY_TO_PROJECT_ID: Record<ECountry, string> = {
  [ECountry.ARGENTINA]: 'rux1jt4r6j',
  [ECountry.MEXICO]: 'smitr20jsw',
  [ECountry.BRAZIL]: 'smit5basf0'
};

function Clarity(): null {
  const { loading, country } = useStoreContext();

  useEffect(() => {
    if (loading) return;
    if (!country) return;

    const projectId = COUNTRY_TO_PROJECT_ID[country];
    if (!projectId) return;

    if (typeof window === 'undefined') return;
    if (window.__clarityInjected) return;

    (function (c: any, l: Document, a: string, r: string, i: string) {
      c[a] =
        c[a] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (c[a].q = c[a].q || []).push(arguments);
        };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode?.insertBefore(t, y);
    })(window as any, document, 'clarity', 'script', projectId);

    window.__clarityInjected = true;
  }, [loading, country]);

  return null;
}

export default Clarity;
